export const IS_EMPTY: string = '1221560910'
export const IS_INVALID_EMAIL: string = '1221559976'
